import { Box, Text, Link as ChakraLink } from '@chakra-ui/react';
import { ChevronRightIcon } from '@chakra-ui/icons';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useIntl } from 'react-intl';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items?: BreadcrumbItem[];
}

export function Breadcrumb({ items }: BreadcrumbProps) {
  const router = useRouter();
  const intl = useIntl();

  // 如果没有传入items，根据当前路径自动生成
  const defaultItems: BreadcrumbItem[] = [
    {
      label: intl.formatMessage({
        defaultMessage: '首页',
        id: 'breadcrumb.home',
      }),
      href: '/',
    },
  ];

  if (router.pathname === '/buy' || router.pathname.startsWith('/buy/')) {
    defaultItems.push({
      label: intl.formatMessage({
        defaultMessage: '购买',
        id: 'breadcrumb.buy',
      }),
      href: '/buy',
    });
  }

  if (router.pathname === '/contact') {
    defaultItems.push({
      label: intl.formatMessage({
        defaultMessage: '联系我们',
        id: 'breadcrumb.contact',
      }),
    });
  }

  const breadcrumbItems = items || defaultItems;

  // 如果只有一个项目（首页），也显示面包屑
  // 注释掉原来的条件，让首页也显示面包屑
  // if (breadcrumbItems.length <= 1 && router.pathname === '/') {
  //   return null;
  // }

  return (
    <nav
      aria-label={intl.formatMessage({
        defaultMessage: '面包屑导航',
        id: 'breadcrumb.aria_label',
      })}
    >
      <Box
        display="flex"
        alignItems="center"
        fontSize="sm"
        color="gray.600"
        mb={4}
      >
        {breadcrumbItems.map((item, index) => (
          <Box key={index} display="flex" alignItems="center">
            {index > 0 && <ChevronRightIcon mx={2} color="gray.400" />}
            {item.href ? (
              <Link href={item.href} passHref>
                <ChakraLink
                  color="blue.500"
                  _hover={{ textDecoration: 'underline' }}
                >
                  {item.label}
                </ChakraLink>
              </Link>
            ) : (
              <Text color="gray.700" fontWeight="medium">
                {item.label}
              </Text>
            )}
          </Box>
        ))}
      </Box>
    </nav>
  );
}
